import { HttpContextToken } from '@angular/common/http';

// Create a context token for passing AbortSignal to HTTP interceptors
export const ABORT_SIGNAL = new HttpContextToken<AbortSignal | undefined>(
    () => undefined
);
